import {
  IconProps,
  TextProps,
} from 'spindl-shared-components';


type NumberColumnInternalProps = {
  icon?: IconProps;
  text?: TextProps;
};

type NumberColumnPropsValues = {
  'CellHovered': NumberColumnInternalProps;
  'CellSelected': NumberColumnInternalProps;
  'Disabled': NumberColumnInternalProps;
  'Number': NumberColumnInternalProps;
  'Spacer': NumberColumnInternalProps;
};

const propValues: NumberColumnPropsValues = {
  'CellHovered': {
    icon: {
      asset: 'Expand',
      colour: 'IconPrimary',
    },
  },
  'CellSelected': {
    icon: {
      asset: 'Expand',
      colour: 'IconPrimary',
    },
  },
  'Disabled': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Disabled',
      type: 'Heading5',
    },
  },
  'Number': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading5',
    },
  },
  'Spacer': {
  },
};

const getProps = (type: string): NumberColumnInternalProps => {
  const values: NumberColumnInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
